import ReactDOM from 'react-dom/client';
import HandcraftsByAbu from './handcraftsbyabu';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<HandcraftsByAbu />);
